import {useMemo} from 'react';
import {useEventParticipants} from './useEventParticipants';

export function useHasFavoriteParticipants(eventId) {
    const participants = useEventParticipants(eventId);
    return useMemo(() => !!participants.find(p => p.is_favorite), [participants]);
}
